import React from 'react'
import { ReactComponent as MenuSVG } from '../../lib/assets/icons/menu.svg'
import { ReactComponent as Raise } from '../../lib/assets/icons/raise.svg'
import { ReactComponent as Turn } from '../../lib/assets/icons/turn.svg'
import { ReactComponent as River } from '../../lib/assets/icons/river.svg'
import { ReactComponent as Bet } from '../../lib/assets/icons/bet.svg'
import { ReactComponent as Check } from '../../lib/assets/icons/check.svg'
import { colors } from '../../lib/colors'

export const GAME_DESCRIPTION = {
  title: 'Texas Hold’em',
  description: [
    `The main idea behind the game is to get a combination of cards that will beat the dealer. The rest is up to us if we play to the end.`,
    `The game has one deck. The player clicks on chips of the selected denomination and then on the Ante field to place an Ante bet.`,
    `After betting, the player clicks "DEAL" for the cards to be dealt. To start, the player is dealt two cards face-up. Next, the dealer is dealt two cards face-down. After five table cards are dealt, the dealer's cards are flipped.`,
    `The player's and dealer's cards are compared to determine who can make the best 5-card poker hand using their two cards and the five table cards. The best five-card poker hand wins.`,
  ],
}

export const settings = [
  {
    icon: <MenuSVG className='menu' />,
    title: 'Settings Button',
    description: 'Press the button to access Settings',
    background: colors.secondary,
    color: colors.tertiaryDark,
  },
  {
    title: 'Provably Fair',
    description:
      'This section grants you the possibility of checking the fairness of the game for yourself',
  },
  {
    title: 'Game Rules',
    description: 'Short Description of the Game',
  },
  {
    title: 'History',
    description:
      'Shows your previous plays and allows you to devise new tactics for your next shuffle',
  },
  {
    title: 'Bet Reply',
    description: 'Click on any bet in history page to see your bet reply',
  },
  {
    title: 'Music',
    description: 'Turn on the unique audio overlay of the game',
  },
  {
    title: 'Sound',
    description: 'Enable unique action sounds of the game',
  },
  {
    title: 'Volume Bar',
    description: 'Set the volume',
  },
]

export const GameplayCustomization = [
  {
    title: 'Ante Bet',
    description:
      'Place a bet on the given position for playing (mandatory bet)',
    icon: '0',
    background: colors.primaryLight,
    textColor: colors.tertiary,
    size: '16px',
    width: '56px',
    height: '56px',
  },
  {
    title: 'Raise Position',
    description: 'Raise amount will be displayed here',
    icon: <Raise />,
    background: colors.primaryLight,
    color: colors.tertiary,
    size: '16px',
    width: '56px',
    height: '56px',
  },
  {
    title: 'Turn Position',
    description: 'Turns amount will be displayed here',
    icon: <Turn />,
    background: colors.primaryLight,
    color: colors.tertiary,
    size: '16px',
    width: '56px',
    height: '56px',
  },
  {
    title: 'River Position',
    description: 'Rivers amount will be displayed here',
    icon: <River />,
    background: colors.primaryLight,
    color: colors.tertiary,
    size: '16px',
    width: '56px',
    height: '56px',
  },
  {
    title: 'Undo Button',
    description: 'Clears last bet',
    icon: 'UNDO',
    background: colors.primaryDark,
    textColor: colors.secondary,
    size: '12px',
    width: '105px',
    height: '36px',
  },
  {
    title: 'Deal Button',
    description: 'Start the game',
    icon: 'DEAL',
    background: colors.secondary,
    textColor: colors.primaryDark,
    size: '12px',
    width: '105px',
    height: '36px',
  },
]
export const ButtonContent = [
  {
    name: 'FOLD',
    title: 'Fold Button',
    class: 'fold',
    icon: <Raise />,
    description:
      'In case of a not-so-good card combination, press the Fold button to stop the game and then start playing a new round.',
    background: colors.primaryDark,
    color: colors.quaternary,
    size: '12px',
  },
  {
    name: 'RAISE',
    title: 'Raise Button',
    icon: <Raise />,
    class: 'raise',
    description:
      'In case of a good card combination, press the Raise button and automatically place a double bet of the ante. The 4th and 5th cards are opened, and the winner is revealed.',
    background: colors.secondary,
    color: colors.primaryDark,
    size: '12px',
  },
  {
    name: 'CHECK',
    class: 'check',
    title: 'Check Button',
    description:
      'In case of a not-so-good card, press the Check button, and the 5th card (river) is dealt on the table (face-up) without automatically making a bet on the Ante bet amount in the River position. The dealer`s cards are opened and the winner is revealed.',
    icon: <Check />,
    background: colors.primaryDark,
    color: colors.quaternary,
    size: '12px',
  },
  {
    name: 'BET',
    class: 'bet',
    title: 'Bet Button',
    description:
      'In case of a good card combination, press the BET button and the ante amount bet is automatically placed in the next position.',
    icon: <Bet />,
    background: colors.secondary,
    color: colors.tertiary,
    size: '12px',
  },
]
export const otherCoefs = {
  coefs: ['2', '2', '2', '2', '2', '2', '2', '2', '2', '2'],
}
